export const validatePassword = (password: string) => {
  const minLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return {
    isValid: minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar,
    requirements: {
      minLength,
      hasUpperCase,
      hasLowerCase,
      hasNumber,
      hasSpecialChar,
    },
  };
};

export const validateFullName = (fullName: string) => {
  const nameParts = fullName.trim().split(/\s+/).filter(part => part.length > 0);
  
  const hasExactlyTwoWords = nameParts.length === 2;
  const noNumbers = !/\d/.test(fullName);
  const validNameLengths = nameParts.every(part => part.length >= 2);
  const validCharacters = /^[A-Za-zÀ-ÖØ-öø-ÿ'-]+\s[A-Za-zÀ-ÖØ-öø-ÿ'-]+$/.test(fullName.trim());
  
  return {
    isValid: hasExactlyTwoWords && noNumbers && validNameLengths && validCharacters,
    firstName: nameParts[0] || '',
    lastName: nameParts[1] || '',
    error: !hasExactlyTwoWords ? "Please enter exactly two names (first and last name)"
          : !noNumbers ? "Names cannot contain numbers"
          : !validNameLengths ? "Each name must be at least 2 characters long"
          : !validCharacters ? "Names can only contain letters and basic special characters"
          : ""
  };
};

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}; 